import { FeatureFlags } from '@/modules/featureFlags';
import { useFeatureFlag } from '@/modules/featureFlags/hooks';

const useMultipleEmployerIdsFeatureFlag = () => {
  const isEnabled = useFeatureFlag(FeatureFlags.MULTIPLE_EMPLOYER_IDS_REPORT);

  return isEnabled;
};

export default useMultipleEmployerIdsFeatureFlag;
